import { Route, Switch } from 'react-router-dom';

import PageNotFound from '../../components/page-not-found';
import Returns from '../../components/returns';
import ThankYou from '../../components/returns/thank-you';

const ReturnsContainer = () => (
  <Switch>
    <Route exact path='/returns/thank-you' component={ThankYou} />
    <Route path='/returns' component={Returns} />
    <Route component={PageNotFound} />
  </Switch>
);

export default ReturnsContainer;
